import RemoteCollection from "./RemoteCollection";

class LazyLoadingRemoteCollection extends RemoteCollection {
  constructor(url) {
    super(url);
    this.page = 0;
    this.total = null;
    this.lastPage = 1;
  }

  allLoaded() {
    return this.page === this.lastPage;
  }

  hasMore() {
    return !this.allLoaded();
  }

  load() {
    if (this.hasMore()) {
      this.page++;
      super.load();
    }

    return this;
  }

  resolveParams(params) {
    return Object.assign(params, {
      "page[number]": this.page
    });
  }

  whenLoaded(data) {
    this.page = data.meta.current_page;
    this.take(data.meta.per_page);
    this.lastPage = data.meta.last_page;
    this.total = data.meta.total;
    return super.whenLoaded(data);
  }

  setData(data) {
    data.forEach(item => this.data.push(item));
  }

  reset() {
    this.data = [];
    this.page = 0;
    this.total = null;
    this.lastPage = 1;
    return this;
  }
}

export default LazyLoadingRemoteCollection;
